import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Menu, Dropdown, Divider } from "antd";
import {Link} from "react-router-dom";
import {
    Logout,
} from 'react-cognito';
import LogoutButton from '../AuthComponents/LogoutButton';
import {connect} from "react-redux";
import FileConstants from '../../../FileConstants';

const CUSTOMER_USERNAME = FileConstants.CUSTOMER_USERNAME;

// Avatar color palette
const AVATAR_COLORS = [
    '#ffa39e', // Red 3
    '#ffbb96', // Volcano 3
    '#ffd591', // Orange 3
    '#ffe58f', // Gold 3
    '#b7eb8f', // Green 3
    '#87e8de', // Cyan 3
    '#91d5ff', // Blue 3
    '#adc6ff', // Geek Blue 3
    '#d3adf7', // Purple 3
    '#ffadd2', // Magenta 3
];

const getAvatarColor = (username) => {
    if (!username) return AVATAR_COLORS[0];
    
    let hash = 0;
    for (let i = 0; i < username.length; i++) {
        hash = username.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    const index = Math.abs(hash) % AVATAR_COLORS.length;
    return AVATAR_COLORS[index];
};

function clearLocalStorage(){
    Object.keys(localStorage).forEach((key) => {
          localStorage.removeItem(key);
      });
    window.history.pushState("ALL3D Console", "ALL3D Console", "/");
}


const UserButton = (props) => {
    const [tourStep, setTourStep] = useState(new URLSearchParams(window.location.search).get("step_no"));
    const [dropdownParams, setDropdownParams] = useState(new URLSearchParams(window.location.search).get("account_dropdown"));
    const [visibleTour, setVisibleTour] = useState(false);
    const firstName = props?.cognito?.attributes?.given_name
    const lastName = props?.cognito?.attributes?.family_name
    var username = localStorage.getItem("username");
    const avatarColor = getAvatarColor(username);

    const getInitials = () => {
        if (firstName && lastName) {
            return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
        }
        if (username && !username.startsWith('google')) {
            return username.charAt(0).toUpperCase();
        }
        return null;
    };

    const initials = getInitials();

    if (firstName && lastName) {
        username = `${firstName} ${lastName}`
    }
    else if (username?.startsWith('google')){
        username = 'Loading...'
    }

    useEffect(() => {
        if (tourStep=='3' && dropdownParams) {
            setVisibleTour(true);
        }
    })

    const onVisibleChange = () => {
        setVisibleTour(!visibleTour);
    }

    const goToSettings = (e) => {
        if (e.key == 0) {
          window.location.href = "/account-details?tab=subs"
        } else if (e.key == 1) {
          window.location.href = "/account-details?tab=profile"
        } else if (e.key == 2) {
          window.location.href = "/account-details?tab=billing"
        } else if (e.key == 3) {
          window.location.href = "/account-details?tab=payment"
        } else if (e.key == 4) {
          window.location.href = "/groups"
        } else if (e.key == 5) {
          window.location.href = "/account-details?tab=company-users"
        } else if (e.key == 6) {
          window.location.href = "/integrations"
        }  else if (e.key == 7) {
          window.location.href = "/account-usage"
        }
    }

    const menu = (user_type) => {
        return <Menu>
            {/* {user_type == 2 ?
                <>
                    <Menu.Item key="2" disabled={tourStep == '3' && dropdownParams} className='manrope f-14 w-400'>
                        {<Link to='/account-details'>
                            <span data_tut="reactour__accountOption">Account Details</span>
                        </Link>}
                    </Menu.Item>
                    <Menu.Item key="5" onClick={() => window.location.href = "/company-users"} className='manrope f-14 w-400'>
                        Company Settings
                    </Menu.Item>
                </>
                :
                ""} */}
            {/* {user_type == 2 ?
            <Menu.Item key="4" onClick={() => window.location.href = "/home/?step_no=5"}>
                Help
            </Menu.Item>: ''
            } */}
            {user_type == 2 ?
            <>
            <Menu.Item key="0" className='manrope f-14 w-400' onClick={goToSettings} >
                <span >Current plan</span>
            </Menu.Item>
            <Menu.Item key="1" className='manrope f-14 w-400'  onClick={goToSettings} >
                <span>Profile</span>
            </Menu.Item>
            <Menu.Item key="2" className='manrope f-14 w-400' onClick={goToSettings} >
                <span>Billing info</span>
            </Menu.Item>
            <Menu.Item key="3" className='manrope f-14 w-400'  onClick={goToSettings} >
                <span>Payment history</span>
            </Menu.Item>
            <Menu.Item key="5" className='manrope f-14 w-400' onClick={goToSettings} >
                <span>Users</span>
            </Menu.Item>
            <Divider className="settings-divider"/>
            </>
            : ''}
            <Menu.Item key="3" className='manrope f-14 w-400'>
                <Logout onLogout={clearLocalStorage}>
                    <LogoutButton />
                </Logout>
            </Menu.Item>
        </Menu>
    };
    
        
    return (
        <div className="user-btn">
            <Dropdown onVisibleChange={onVisibleChange} visible={visibleTour} overlay={menu(props.user_type)}  trigger={["click"]}>
                <a className="ant-dropdown-link justify-in-center" href="" style={{display: 'flex'}}>
                    <Avatar 
                        className="pic" 
                        style={{ 
                            backgroundColor: avatarColor, 
                            color: '#333',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        icon={!initials ? <UserOutlined /> : null}
                    >
                        {initials}
                    </Avatar>
                    <span className="username manrope f-14 w-700">{username}</span>
                    <span className="float-right">
                            <DownOutlined className="user-arrow-down" />
                    </span>
                </a>
            </Dropdown>
        </div>

    );
    
}
const mapStateToProps = state => state;
export default connect(
    mapStateToProps
)(UserButton)
